//CSS
import "../../Components/Page/Page.css";


//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ContentButton from "../../Components/ContentButton/ContentButton";
import { faStore, faTruck } from '@fortawesome/free-solid-svg-icons';      // storefront
import Button from "../../Components/Button/Button";
import NorthAmericaMap from "../../Components/Map/MapComp";
import { useNavigate } from "react-router-dom";
import { geoPath, geoAlbersUsa } from 'd3-geo';
import { feature } from 'topojson-client';
import { FeatureCollection, Geometry, GeoJsonProperties } from 'geojson';
import CA from 'country-flag-icons/react/3x2/CA';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MyComponent = () => <CA title="Canada" />;


const ARIZONA_FIPS = '04'; // Arizona's state FIPS code

async function getArizonaSVGPath(): Promise<string> {
    const res = await fetch('https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json');
    const us = await res.json();

    // Cast to FeatureCollection so TypeScript knows .features exists
    const states = feature(us, us.objects.states) as unknown as FeatureCollection<Geometry, GeoJsonProperties>;

    const arizona = states.features.find((f) => f.id === '04');

    if (!arizona) throw new Error('Arizona not found');

    const projection = geoAlbersUsa().scale(4000).translate([900, 0]);
    const pathGenerator = geoPath().projection(projection);

    return pathGenerator(arizona) ?? '';
}

// Usage in a React component
const ArizonaMap = () => {
    const [path, setPath] = React.useState<string>('');

    React.useEffect(() => {
        getArizonaSVGPath().then(setPath);
    }, []);

    return (
        <svg viewBox="0 0 100 500" width="20vw" height="20vw" >
            <path d={path} fill="#fff" stroke="#333" strokeWidth="1" />
        </svg>
    );
};


interface TimelineText {
    headLine: string;
    text: string;
    readMore: string;
}



const TradeShowNews: React.FC = () => {

    const navigate = useNavigate();

    const goToArizona = () => {
        navigate('/arazona-tech-week-2026');
    };

    const goToMississauga = () => {
        navigate('/mississauga-truck-world-2026');
    };

    return (
        <div className="sectionContainer">
            <SecHeader title="Trade Shows" />
            <SubSection isSplit={false}>
                {/* <NorthAmericaMap /> */}
                <ContentButton click={goToMississauga}>
                    <p>
                        <h1>Toronto</h1>
                    </p>
                    <p>
                        <h2>Truck World</h2>
                    </p>
                    <p>
                        <FontAwesomeIcon icon={faTruck} size="4x" />
                        {/* <CA title="Canada"  style={{ borderRadius: '16px' }}/> */}

                    </p>
                    <p>
                        <b>April 16-18, 2026</b>
                    </p>
                </ContentButton>
                {/* <br /> */}
                {/* <ContentButton click={goToArizona}>
                    <p>
                        <h1>Phoenix</h1>
                    </p>
                    <p>
                        <h2>Arizona Tech Week</h2>
                    </p>
                    {ArizonaMap()}
                    <p>
                        <b>April 6-12, 2026</b>
                    </p>
                </ContentButton> */}

                {/* <Button name="scroll-button" text="" type="" wnum={200}href='./request-info' iconPath={faStore} /> */}

            </SubSection>
        </div>
    );
};

export default TradeShowNews;